import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import { submitForm } from "../../../utils/apiUtils";
import CodeEditor from "../../../Components/CodeEditor";
import { Button } from "reactstrap";
import Upload from "../../../Components/upload";
import getFileType, { SwitchToggle } from "../../../helper/ImageFormat";
import Select from "react-select";
import { selectStyles } from "../../../utils/selectStyles";

const AddPagewisebanner = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const editingId = editData?.id;
  const [menudata, setmenudata] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    FetchMenudata();
  }, []);
  const [data, setData] = useState({
    menu_id: editData?.menu_id || "",
    title: editData?.title || "",
    description: editData?.description || "",
    desktopImage: editData?.desktopImage || "",
    mobileImage: editData?.mobileImage || "",
    bannerType: editData?.bannerType || "",
    isActive: editData?.isActive ?? true,
  });

  const [errors, setErrors] = useState({
    menu_id: "",
    title: "",
    desktopImage: "",
    mobileImage: "",
    description: "",
    bannerType: "",
  });

  const handleChange = (e) => {
    const { name, checked, value } = e.target;
    if (name === "bannerType") {
      setData({
        ...data,
        [name]: value,
      });
    } else if (name === "desktopImage" || name === "mobileImage") {
      setData({ ...data, [name]: null });
    } else if (name === "isActive") {
      setData({ ...data, [name]: checked });
    } else {
      setData({ ...data, [name]: value });
    }

    setErrors({ ...errors, [name]: "" });
  };

  const FetchMenudata = async () => {
    try {
      const response = await axiosInstance.get("/menu?params=all");
      if (response.status === 200) {
        setmenudata(response.data?.data);
      }
    } catch (error) {
      const responseError = error?.response?.data?.message;
      toast.error(responseError);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   await submitForm({
  //     data,
  //     url: "/pagebanner",
  //     editingId,
  //     validateFields: [
  //       { name: "menu_id", message: "Menu id is required" },
  //       { name: "desktopImage", message: "Desktop image is required" },
  //       { name: "mobileImage", message: "Mobile image is required" },
  //       { name: "bannerType", message: "Banner type is required" },
  //       { name: "title", message: "Title is required" },
  //     ],
  //     validationErrorsSetter: setErrors,
  //     navigate: () => navigator("/page-banner"),
  //   });
  //   setLoading(false);
  // };


  const handleSubmit = async (e) => {
  e.preventDefault();

  let newErrors = {};

  if (!data.menu_id) newErrors.menu_id = "Menu id is required";
  if (!data.bannerType) newErrors.bannerType = "Banner type is required";
  if (!data.title) newErrors.title = "Title is required";

  if (!data.desktopImage) newErrors.desktopImage = "Desktop file is required";
  if (!data.mobileImage) newErrors.mobileImage = "Mobile file is required";
  if (data.desktopImage) {
    const type = getFileType(data.desktopImage);

    if (data.bannerType === "Image" && type !== "image") {
      newErrors.desktopImage = "Please upload an image file";
    }

    if (data.bannerType === "Video" && type !== "video") {
      newErrors.desktopImage = "Please upload a video file";
    }
  }

  if (data.mobileImage) {
    const type = getFileType(data.mobileImage);

    if (data.bannerType === "Image" && type !== "image") {
      newErrors.mobileImage = "Please upload an image file";
    }

    if (data.bannerType === "Video" && type !== "video") {
      newErrors.mobileImage = "Please upload a video file";
    }
  }

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  setLoading(true);

  await submitForm({
    data,
    url: "/pagebanner",
    editingId,
    validateFields: [],
    validationErrorsSetter: setErrors,
    navigate: () => navigator("/page-banner"),
  });

  setLoading(false);
};

  const handleUploadChange = (file, fieldName) => {
    setErrors({ ...errors, [fieldName]: "" });
    setData({ ...data, [fieldName]: file });
  };


  const generateMenuOptions = (menus, level = 0) =>
    menus.flatMap((menu) => {
      const prefix = level > 0 ? "-- ".repeat(level) : "";
      const currentOption = {
        value: menu.id,
        label: `${prefix}${menu.label}${level === 0 && menu.children?.length ? " (Parent)" : ""}`,
      };
      const childOptions = menu.children?.length ? generateMenuOptions(menu.children, level + 1) : [];
      return [currentOption, ...childOptions];
    });

  const parentMenuOptions = generateMenuOptions(menudata);

  const bannerTypeOptions = [
  { value: "Image", label: "Image" },
  { value: "Video", label: "Video" },
];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5 mx-4">
          <h3 className="page-title">
            {" "}
            {editData ? "Update" : "Add"} page wise banner
          </h3>
        </div>
        <div className="col-md-12 grid-margin stretch-card">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <form className="pt-3" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="category_id" className="col-form-label ">
                          Page Name
                        </label>

                        <Select
                          options={parentMenuOptions}
                          value={
                            parentMenuOptions.find((option) => option.value === data.menu_id) ||
                            null
                          }
                          onChange={(selectedOption) => {
                            setData((prev) => ({ ...prev, menu_id: selectedOption?.value || "" }));
                            setErrors((prev) => ({ ...prev, menu_id: "" }));
                          }}
                          isClearable
                          placeholder="Select Page Name"
                          
                          styles={selectStyles}
                        />



                        {errors.menu_id && (
                          <small className="text-danger">{errors.menu_id} </small>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="bannerType" className="col-form-label ">
                          Banner Type
                        </label>
                        <Select
  options={bannerTypeOptions}
  value={bannerTypeOptions.find(option => option.value === data.bannerType) || null}
  onChange={(selectedOption) => {
    setData((prev) => ({ ...prev, bannerType: selectedOption?.value || "" }));
  }}
  placeholder="Select type"
  isClearable
  styles={selectStyles}
/>
                        {errors.bannerType && (
                          <small className="text-danger">{errors.bannerType}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername2" className="col-form-label ">
                          Banner Title
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm border border-dark"
                          id="title"
                          name="title"
                          placeholder="Enter title"
                          value={data.title}
                          onChange={handleChange}
                        />
                        {errors.title && (
                          <small className="text-danger">{errors.title}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="desktopImage" className="col-form-label ">
                          Desktop {data.bannerType} File (1400px X 395px)
                        </label>
                        <Upload
                          label="mobileImage"
                          initialImage={data.desktopImage}
                          onChange={(file) => handleUploadChange(file, "desktopImage")}
                          apiUrl={"uploads?label=pageBanner"}
                        />
                        {errors.desktopImage && (
                          <small className="text-danger">{errors.desktopImage}</small>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="desktopImage" className="col-form-label ">
                          Mobile {data.bannerType} File (540px X 658px)
                        </label>
                        <Upload
                          label="mobileImage"
                          initialImage={data.mobileImage}
                          onChange={(file) => handleUploadChange(file, "mobileImage")}
                          apiUrl={"uploads?label=pageBanner"}
                        />
                        {errors.mobileImage && (
                          <small className="text-danger">{errors.mobileImage}</small>
                        )}
                      </div>
                    </div>



                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername2" className="col-form-label">
                          Description
                        </label>
                        <CodeEditor
                          value={data.description}
                          style={{ height: "400px" }}
                          onChange={(value) =>
                            handleChange({
                              target: {
                                name: "description",
                                value,
                              },
                            })
                          }
                        />
                        {errors.description && !data?.description?.trim() && (
                          <small className="text-danger">Description is required</small>
                        )}
                      </div>
                    </div>



                    <div className="col-md-12 mt-4 p-2" >
                      <SwitchToggle
                        checked={data.isActive}
                        onChange={(val) => setData((prev) => ({ ...prev, isActive: val }))}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-center mt-4">
                    <Button type="submit" color="primary" disabled={loading}>
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          {editData ? "Updating..." : "Submitting..."}
                        </>
                      ) : editData ? (
                        "Update"
                      ) : (
                        "Add"
                      )}
                    </Button>
                    <Link to="/page-banner">
                      <Button className="ml-3" type="submit" color="danger" disabled={loading}>Cancel</Button>
                    </Link>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPagewisebanner;
